
import { createContext, useContext, useRef, useState } from "react";
import { createDecartClient } from "@decartai/sdk";
import { decartToken } from "../ApiServices/chatServices";

const DecartContext = createContext(null);

export const useDecart = () => useContext(DecartContext);

export const DecartProvider = ({ children }) => {
  const decartClientRef = useRef(null);
  const [notification, setNotification] = useState(null);

    // Show notification helper
  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
  };


  const initDecart = async () => {
    decartToken((response) => { // for env variables 
        if (response?.data?.client_token) {
          decartClientRef.current = createDecartClient({
            apiKey: response.data.client_token,
          });
        } else {
          showNotification("Token missing", 'error');
        }
        }, (err) => {
          showNotification("Error fetching token", 'error');
        });
  };

  return (
    <DecartContext.Provider value={{ decartClientRef, initDecart, notification }}>
      {children}
    </DecartContext.Provider>
  );
};
